export const rad2deg = 180 / Math.PI;
export const deg2rad = Math.PI / 180;
export const inch2cm = 2.54;
export const mm2cm = 0.1;
export const cm2mm = 10;
export const value2percent = 0.01;
export const mmUnit = " mm";
export const degreeUnit = "°";
export const percentUnit = "%";
export const defaultMeshGenerationParameters = {
    numVertices: { x: 128, y: 64, z: 24 },
    sideRoundness: 0.1,
    normalGenerationMode: "UseMeshGeometry",
    needUVs: false,
    needTriangles: true,
    needLines: false,
    sideRoundingMode: "CircleArcs", // mindig CircleArcs kell legyen (LEOINSOLE-181)
    useLegacySideSurfaceGeneration: false, // HP-s domaineken kell true-nak lennie, minden másnál pedig false-nak (LEOINSOLE-181)
};
export const defaultExportParameters = {
    hasPlantarPattern: false,
    embossedLogo: false,
    embossedFiducial: false,
    embossedFontSize: 1.5,
    embossedDepth: 0.05,
    embossedTextPositionUV: { x: 0.842, y: 0.5 },
    embossedTextOffset: { x: 0, y: 0 },
    embossedRotationDegrees: 0,
    numVertices: { x: 256, y: 128, z: 24 },
    embossedText: "",
    embossedFontFamily: "",
    embossedLogoNameOverride: "",
    generateLatticeMesh: false,
    generateLatticeMeshPreview: true,
};
//# sourceMappingURL=parameters.js.map